import {AfterViewInit, Component} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService
} from "../../../core";
import {MenuType, OneSwitchMenuElement} from "../../../models";

@Component({
    selector: 'one-switch',
    templateUrl: './one-switch.component.html',
    styleUrls: ['./one-switch.component.scss']
})
export class OneSwitchComponent implements AfterViewInit  {
    constructor(
        private icon: IconService,
        public control: ControlService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setIcon(val:  number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    resetValue() {
        const elementVal = this.control.elementVal.getValue() as OneSwitchMenuElement;

        elementVal.params.value = elementVal.params.default > elementVal.params.min
                ? elementVal.params.default
                : elementVal.params.min;
        this.control.elementVal.next(elementVal);
    }
}
